import { JOB_RESIDENCE_STATUS } from "@/types/enum";

export const isExemptSpecifiedSkillCert = (jobResidenceStatusIds: number[], talentResidenceStatusLabel?: string): boolean => {
  const isJobEngineerHumanities = jobResidenceStatusIds.includes(JOB_RESIDENCE_STATUS.ENGINEER_HUMANITIES);
  const isJobOther = jobResidenceStatusIds.includes(JOB_RESIDENCE_STATUS.OTHER);
  const isTalentSpecifiedSkill = (talentResidenceStatusLabel ?? "").includes("特定技能");

  return isJobEngineerHumanities || (isJobOther && !isTalentSpecifiedSkill);
};
